import React from 'react';
import { Table, Text } from '@chakra-ui/react';

interface EmptyStateProps {
  colSpan: number;
  message: string;
}

export function EmptyState({ colSpan, message }: EmptyStateProps) {
  return (
    <Table.Row>
      <Table.Cell colSpan={colSpan}>
        <Text textAlign="center" color="gray.500">
          {message}
        </Text>
      </Table.Cell>
    </Table.Row>
  );
}

export default EmptyState;